import { redirect } from '@tanstack/react-router';

import { loadRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard of the Code Quality report (`/workspaces/:id/code-quality/:projectId`): sends a deep
 * link home while the Code Quality flag is off. The config is read again on each navigation, so a
 * tab left open honours a switch flipped later. Unlike the other section guards it fails closed,
 * because the flag itself does.
 */
export async function ensureCodeQualityEnabled(): Promise<void> {
  const config = await loadRuntimeConfig(true);
  if (!config.features.codeQuality) {
    throw redirect({ to: '/' });
  }
}
